const Ticker = {
  resizeTimeout: null,
  previousWindowInnerWidth: window.innerWidth,
  SELECTORS: {
    container: '[data-js-ticker]',
    content: '[data-js-ticker-content]',
    text: '[data-js-ticker-text]',
    textClone: '[data-js-ticker-text-clone]',
  },
  CLASSES: {
    containerActive: 'ticker--active',
  },
  CSS_VARIABLES: {
    animationDuration: '--ticker-animation-duration',
  },
  init() {
    this.initializeTickers(document);
  },
  initializeTickers(parentElement) {
    const containerElements = parentElement.querySelectorAll(this.SELECTORS.container);

    containerElements.forEach((containerElement) => {
      this.initializeTicker(containerElement);
    });
  },
  initializeTicker(containerElement) {
    const isMotionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (isMotionReduced) {
      return;
    }

    const contentElement = containerElement?.querySelector(this.SELECTORS.content);
    const textElement = contentElement?.querySelector(this.SELECTORS.text);

    if (!textElement) {
      return;
    }

    containerElement.classList.add(this.CLASSES.containerActive);

    const textCloneElements = contentElement.querySelectorAll(this.SELECTORS.textClone);

    for (let i = 0; i < textCloneElements.length; i++) {
      textCloneElements[i].remove();
    }

    const referenceElementScrollWidth = textElement.scrollWidth;
    let multiplier = 2;

    if (referenceElementScrollWidth !== 0) {
      multiplier = 2 * Math.ceil(containerElement.offsetWidth / referenceElementScrollWidth);
    }

    for (let i = 0; i < multiplier - 1; i++) {
      const clonedNode = textElement.cloneNode(true);
      const textDataAttribute = this.SELECTORS.text.replace('[', '').replace(']', '');
      const textCloneDataAttribute = this.SELECTORS.textClone.replace('[', '').replace(']', '');

      clonedNode.removeAttribute(textDataAttribute);
      clonedNode.setAttribute(textCloneDataAttribute, '');
      clonedNode.ariaHidden = true;

      textElement.after(clonedNode);
    }

    containerElement.style.setProperty(this.CSS_VARIABLES.animationDuration, `${contentElement.offsetWidth / 120}s`);

    contentElement.style.animation = 'none';
    contentElement.offsetHeight;
    contentElement.style.animation = null;
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Ticker.init();
});

document.addEventListener('shopify:section:load', () => {
  Ticker.init();
});

document.addEventListener('shopify:section:reorder', () => {
  Ticker.init();
});

function reinitializeTickerOnWindowResize() {
  if (window.innerWidth === Ticker.previousWindowInnerWidth) {
    return;
  }

  Ticker.previousWindowInnerWidth = window.innerWidth;

  clearTimeout(Ticker.resizeTimeout);

  Ticker.resizeTimeout = setTimeout(() => {
    Ticker.init();
  }, 1000);
}

window.addEventListener('resize', () => {
  reinitializeTickerOnWindowResize();
});

window.Ticker = Ticker;
